<style lang="scss" scoped>
.impersonate-as {
    background: #fff;
    position: fixed;
    top: 16px;
    right: 16px;
    padding: 4px 16px;
    z-index: 1000;
    border-radius: 2px;
    display: flex;
    flex-flow: column;
}
</style>

<template>
    <div>
        <router-view :key="$route.path" />

        <div v-if="isImpersonating" class="impersonate-as">
            <p class="text-primary-dark small mb-0"><strong>Impersonating: </strong>{{ currentUser.first_name }}</p>
            <a class="small text-gold" href="javascript:void(0)" @click="stopImpersonating()">Keer terug</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'index',

    methods: {
        stopImpersonating() {
            this.$store.dispatch('user/stopImpersonating').then(
                () => {
                    window.location.href = '/a/dashboard'
                }
            )
        }
    },
    computed: {
        isImpersonating() {
            return this.$store.getters['user/isImpersonating']
        },
        currentUser() {
            return this.$store.getters['user/currentUser']
        }
    }
};
</script>
